import { render } from "./dashboard.html?vue&type=template&id=062f01d4&external"
import script from "./dashboard.js?vue&type=script&lang=js&external"
export * from "./dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__